export const EMAILED_SIGN_IN_FLOW_KEY = "sign-in";

export function hasEmailedSignInMarker(hash: string): boolean {
  return hash.includes(`${EMAILED_SIGN_IN_FLOW_KEY}=`);
}
